import { render } from "./CustomerDetailRetainersTab.vue?vue&type=template&id=bd856518&scoped=true"
import script from "./CustomerDetailRetainersTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailRetainersTab.vue?vue&type=script&lang=js"

import "./CustomerDetailRetainersTab.vue?vue&type=style&index=0&id=bd856518&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd856518"]])

export default __exports__